export default "__VITE_ASSET__be74b867__"